import { apiInstance } from "../index";
export const generalApi = apiInstance.injectEndpoints({
  endpoints: (builder) => ({
    getData: builder.query({
      query: (data) => {
        return {
          url: `LastProductSeller/GetTyaliaLastSellers`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetDataQuery } = generalApi;
